import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { Form, Input, message } from 'antd'
import { apiBuyerModify } from '@/service/api';


const EditPasswordForm = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    try {
      const values = form.getFieldsValue();
      setLoading(true)
      const res = await apiBuyerModify(values);
      if(res.code === 0) {
        message.success(t('d5bdff27'));
        onClose();
        onClose();
      } else {
        message.error(res.msg || t('27604e7c'));
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    
    }
  };

  return (
    <div className='px-[14px] bg-white rounded-[12px] pt-[48px] pb-[76px] flex flex-col justify-start'>
      <LangText lngKey='163c30a4' className='text-[24px] font-bold '>{t('163c30a4')}</LangText>
      <Form form={form} layout="vertical" className='!mt-15' onFinish={handleSubmit}>
        <Form.Item
          name='originPassword'
          required
          label={<LangText lngKey='1ae29ee5' className='text-[16px] font-bold'>{t('1ae29ee5')}</LangText>}
          rules={[
            { required: true, message: t('afe0236e') },
          ]}
        >
          <Input.Password placeholder={t('44739ae4')} className='h-[44px]' autoComplete='current-password' />
        </Form.Item>
        <Form.Item
          name='newPassword'
          required
          label={<LangText lngKey='a141c670' className='text-[16px] font-bold'>{t('a141c670')}</LangText>}
          rules={[
            { required: true, message: t('f039ef62') },
            { min: 6, message: t('69a859b3') },
            { max: 12, message: t('14ea58bf') },
            { pattern: /^[a-zA-Z0-9]+$/, message: t('69069764') },
          ]}
        >
          <Input.Password placeholder={t('44739ae4')} className='h-[44px]' autoComplete='new-password' />
        </Form.Item>
        <Form.Item
          name='newConfirmPassword'
          required
          label={<LangText lngKey='9b848359' className='text-[16px] font-bold'>{t('9b848359')}</LangText>}
          dependencies={['password']}
          rules={[
            { required: true, message: t('928d5f22') },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('81dbebe1')));
              },
            }),
          ]}
        >
          <Input.Password placeholder={t('48194e92')} className='h-[44px]' autoComplete='new-password' />
        </Form.Item>
        <div className='flex items-center mt-[52px] gap-4'>
          <button className='w-[136px] rounded-[24px] border border-[#D9D9D9] h-[44px] cursor-pointer' onClick={onClose}>
            <LangText lngKey='3a2308ec' className='text-[15px] text-[#666666]'>{t('3a2308ec')}</LangText>
          </button>
          <button
            type='submit'
            className={`flex-1 rounded-[24px] bg-linear-to-r from-[#a75aff] to-[#4b51ff] h-[44px] cursor-pointer ${loading ? 'opacity-60' : ''
              }`}
            disabled={loading}
          >
            <LangText lngKey='5aeff2f2' className='text-[15px] text-white'>{loading ? t('3771e3dc') : t('5aeff2f2')}</LangText>
          </button>
        </div>
      </Form>
    </div>
  )
}

export default EditPasswordForm